import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

let initialized = false;

export function initLogRocket() {
	const id = getId();
	console.log(`Logrocket env is prod: ${import.meta.env.PROD}`);
	if (initialized || !import.meta.env.PROD) return;
	if (!id) {
		console.log(`Log rocket id is not set`);
		return;
	}

	LogRocket.init(id);
	setupLogRocketReact(LogRocket);

	initialized = true;
}

function getId(): string | undefined {
	return import.meta.env.VITE_LOG_ROCKET_ID;
}

export { LogRocket, getId };
